var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ml-5 mr-5"},[_c('section',[(_vm.automateOrNoneAutomateMode == 0)?_c('AutomateItemsSelection',{on:{"itemsSelected":_vm.itemsSelected}}):_vm._e(),(_vm.automateOrNoneAutomateMode == 1)?_c('NonAutomateItemsSelection',{on:{"itemsSelected":_vm.itemsSelected}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }